export default __webpack_public_path__ + "static/media/404Error.62c400d0.gif";